import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function CommonTable({
  columns,
  data,
  page,
  totalPage,
  onPageChange,
}) {
  return (
    <div style={{ paddingBottom: "40px" }}>
      {/* Header with Stats/Actions could go here */}

      {/* Pagination Top */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          backgroundColor: "white",
          padding: "16px 20px",
          borderRadius: "var(--radius-lg)",
          boxShadow: "var(--shadow-sm)",
          border: "1px solid var(--glass-border)"
        }}
      >
        <div style={{ fontSize: "14px", color: "var(--text-muted)", fontWeight: "500" }}>
          Showing Page <span style={{ color: "var(--text-main)" }}>{page}</span> of <span style={{ color: "var(--text-main)" }}>{totalPage}</span>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            disabled={page === 1}
            onClick={() => onPageChange(page - 1)}
            className="pagination-btn"
          >
            <ChevronLeft size={16} />
            Prev
          </button>

          <button
            disabled={page >= totalPage}
            onClick={() => onPageChange(page + 1)}
            className="pagination-btn"
          >
            Next
            <ChevronRight size={16} />
          </button>
        </div>
      </div>

      {/* Table Section */}
      <div className="table-container">
        <table className="premium-table">
          <thead>
            <tr>
              <th>SI No.</th>
              {columns.map((col) => (
                <th key={col.key || col.header}>{col.header}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              data.map((row, rowIndex) => (
                <tr key={row._id || rowIndex}>
                  {/* serial index */}
                  <td data-label="SI No.">
                    <span style={{
                      background: "#f1f5f9",
                      padding: "4px 8px",
                      borderRadius: "6px",
                      fontWeight: "600",
                      fontSize: "12px",
                      color: "var(--text-muted)"
                    }}>
                      {(page - 1) * 20 + (rowIndex + 1)}
                    </span>
                  </td>

                  {columns.map((col) => (
                    <td key={col.key || col.header} data-label={col.header}>
                      <div style={{ fontWeight: col.key === 'name' || col.key === 'firstName' ? '600' : '400' }}>
                        {col.render ? col.render(row) : row[col.key]}
                      </div>
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length + 1} style={{ textAlign: "center", padding: "40px", color: "var(--text-muted)" }}>
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Optional: Bottom Pagination for long tables */}
      {totalPage > 1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "24px",
          }}
        >
          <div style={{ display: "flex", gap: "8px" }}>
            {/* Simple page numbers could be added here if needed */}
          </div>
        </div>
      )}
    </div>
  );
}
